import moment from "moment";

export function prepareFaq(faq) {
    faq.socials = faq.socials || {};
    faq.sections?.forEach((section) => {
        section.questions?.sort((a, b) => a.order - b.order);
    });
    return faq;
}
export function prepareWall(wall) {
    wall.author = wall.author || {};
    wall.formColors = wall.formColors || {};
    wall.testimonials = wall.testimonials || [];
    wall.testimonials.forEach((testimonial) => {
        try {
            const images = JSON.parse(testimonial.images);
            testimonial.images = images ? images : [];
        } catch {
            /* eslint-disable-next-line no-empty */
        }

        try {
            const gifs = JSON.parse(testimonial.gifs);
            testimonial.gifs = gifs ? gifs : [];
        } catch {
            /* eslint-disable-next-line no-empty */
        }
    });
    wall.testimonials.sort((a, b) => a.order - b.order);
    return wall;
}

export function prepareForSaveWall(wall) {
    wall.testimonials?.forEach((testimonial) => {
        testimonial.images = JSON.stringify(testimonial.images);
        testimonial.gifs = JSON.stringify(testimonial.gifs);
    });
    return wall;
}

export function preparePricing(pricing) {
    pricing.socials = pricing.socials || {};
    pricing.categories?.forEach((category) => {
        category.variants?.sort((a, b) => a.order - b.order);
    });
    return pricing;
}
export function prepareFooter(footer) {
    footer.companyData = footer.companyData || {};
    footer.categories?.sort((a, b) => a.id - b.id);
    footer.categories?.forEach((category) => {
        category.links.sort((a, b) => a.order - b.order);
    });
    footer.legal = footer.legals?.[0] || {};
    return footer;
}

export function preparePlayer(player) {
    player.files?.sort((a, b) => a.order - b.order);
    player.headers?.sort((a, b) => a.order - b.order);
    player.ecProductIds = JSON.parse(player.ecProductIds);
    player.sendWebhooks = player.sendWebhooks || {};

    if (player.certificate) {
        player.certificate.content = player.certificate.content || {};
    }
    return player;
}

export function preparePage(page) {
    page.colors = page.colors || {};
    page.settings = page.settings || {};
    page.sections?.forEach((section) => {
        section.styles = section.styles || {};
        /*
            if (section.type === "wall") {
                section.wall = prepareWall(section.wall);
            }
            if (section.type === "faq") {
                section.faq = prepareFaq(section.faq);
            }
            if (section.type === "pricing") {
                section.pricing = preparePricing(section.pricing);
            }
        */
    });
    page.sections?.sort((a, b) => a.order - b.order);
    return page;
}

export function prepareCookie(cookie) {
    cookie.consentTypes = cookie.consentTypes || {};
    return cookie;
}

export function prepareForSavePage(page) {
    page.sections.forEach((section) => {
        if (section.type === "wall") {
            section.wall = prepareForSaveWall(section.wall);
        }
    });
    page.sections.sort((a, b) => a.order - b.order);
    return page;
}

const properStringDate = (v) => typeof v === "string" && v !== "Invalid Date" && v !== "null";

export function prepareTimer(timer) {
    // problem with `transparent` saved as string in DB
    if (timer.transparent === "false" || timer.transparent === "0") {
        timer.transparent = 0;
    } else {
        timer.transparent = Number(timer.transparent) || 0;
    }
    const { endDate, endHour } = timer;
    if (properStringDate(endDate) && properStringDate(endHour)) {
        // for now to fix Easy 2.0 control display, strip 'Z' from time (Treat it as local !)
        const [dayDate] = endDate.split("T");
        const nonUTCDate = `${dayDate} ${endHour}`;
        timer.endDate = moment(nonUTCDate).toDate();
    }
    return timer;
}

//TODO:
export function prepareCoffee(coffee) {
    return coffee;
}

//TODO:
export function prepareBanner(banner) {
    return banner;
}

export function prepareTicker(ticker) {
    ticker.ecProductIds = ticker.ecProductIds || [];
    ticker.colors = ticker.colors || {};
    return ticker;
}
